export interface ZoneBoundaryPoint {
  lat: number;
  lng: number;
}

const EARTH_RADIUS_KM = 6371;

/** Lit un périmètre renvoyé par l'API. */
export function readBoundary(value: unknown): ZoneBoundaryPoint[] | null {
  if (!Array.isArray(value) || value.length < 3) return null;

  const points: ZoneBoundaryPoint[] = [];
  for (const item of value) {
    if (!item || typeof item !== "object") return null;
    const lat = (item as { lat?: unknown }).lat;
    const lng = (item as { lng?: unknown }).lng;
    if (typeof lat !== "number" || typeof lng !== "number") return null;
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    points.push({ lat, lng });
  }

  return points;
}

export function hasManualBoundary(value: unknown): boolean {
  return readBoundary(value) != null;
}

/**
 * Transforme un ancien cercle (centre + rayon) en polygone éditable.
 * Même construction que le helper backend, pour afficher la couverture actuelle.
 */
export function circleToPolygon(
  lat: number,
  lng: number,
  radiusKm: number,
  steps = 24,
): ZoneBoundaryPoint[] {
  const angular = radiusKm / EARTH_RADIUS_KM;
  const latRad = (lat * Math.PI) / 180;
  const lngRad = (lng * Math.PI) / 180;
  const points: ZoneBoundaryPoint[] = [];

  for (let i = 0; i < steps; i++) {
    const bearing = (2 * Math.PI * i) / steps;
    const lat2 = Math.asin(
      Math.sin(latRad) * Math.cos(angular) +
        Math.cos(latRad) * Math.sin(angular) * Math.cos(bearing),
    );
    const lng2 =
      lngRad +
      Math.atan2(
        Math.sin(bearing) * Math.sin(angular) * Math.cos(latRad),
        Math.cos(angular) - Math.sin(latRad) * Math.sin(lat2),
      );
    points.push({ lat: (lat2 * 180) / Math.PI, lng: (lng2 * 180) / Math.PI });
  }

  return points;
}
